<template v-if="selectionIsGa">
  <SMList v-on-click-outside="onClickOutside" class="custom-list md-triple-line md-dense" @click.prevent="">
    <SMListItem class="ga-seats-input">
      <span class="label">Count</span>
      <SMNumberInput
        :min="0"
        :max="selection && selection.attributes.capacity"
        :value="count"
        @change="onCountChange"
      />
    </SMListItem>
  </SMList>
</template>
<script lang="ts">
import eventbus from 'tiny-emitter/instance';
import { mapState, mapActions } from 'vuex';
import { TYPE } from '@/constants';
import SMNumberInput from '@/components/ui/SMNumberInput.vue';
import ClickOutside from 'vue-click-outside';

export default {
  props: ['selection'],
  data() {
    return {};
  },
  computed: {
    ...mapState('renderer', ['gaInCart']),
    count() {
      const ga = this.gaInCart.find((s) => s.uuid === this.selection.uuid);
      return (ga && ga.count) || 0;
    },
    selectionIsGa() {
      return this.selection.type === TYPE.GA;
    },
  },
  methods: {
    ...mapActions('renderer', ['updateGaInCart']),
    onClickOutside() {
      eventbus.emit('menu:hide');
    },
    onCountChange(value = 0) {
      this.updateGaInCart({
        label: this.selection.attributes.label.text,
        count: +value,
        uuid: this.selection.uuid,
      });
    },
    onInputClick() {
      // intentionally left blank
    },
  },
  components: { SMNumberInput },
};
</script>
<style lang="scss" scoped>
.ga-seats-input {
  .md-input-container {
    width: 100px !important;
    min-width: 90px !important;
    input {
      padding: 0px 0px 0px 12px;
      min-width: auto !important;
      flex: auto;
    }
  }
  .label {
    font-size: 16px;
  }
}
.md-input-container {
  margin-left: 16px;
}
.md-list {
  width: 197px;
  height: 57px;
  margin-top: 1px;
}
</style>
